import { inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ComponentStore } from '@ngrx/component-store';

import { SystemNotificationsService } from './system-notifications.service';
import { SystemNotificationMessage } from './system-notification-message.model';

export type SystemNotificationsState = {
  notifications: SystemNotificationMessage[];
};

@Injectable()
export class SystemNotificationsStore extends ComponentStore<SystemNotificationsState> {
  private service = inject(SystemNotificationsService);
  readonly notifications = this.selectSignal(state => state?.notifications ?? []);

  constructor() {
    super({ notifications: [] });

    this.service.messages$.pipe(takeUntilDestroyed()).subscribe(message => {
      this.patchState(state => ({
        notifications: [message, ...state.notifications.slice(0, 2)] // business reqs stated that only show up to last 3 notifications
      }));
    });
  }

  removeMessage(uId: string): void {
    this.patchState(state => ({
      notifications: state.notifications.filter(n => n.uId !== uId)
    }));
  }
}
